import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useLoader } from "../context/LoaderContext";
import { fetchGalleryBanner, fetchGalleryData } from "../api/GalleryApi";
import { dynamicFailed } from "../hooks/useToast";
import { useGalleryBannerContext } from "../context/GalleryBannerContext";
import { useGalleryImageContext } from "../context/GalleryImageContext";
import GalleryBanner from "../components/gallery/GalleryBanner";
import GalleryImage from "../components/gallery/GalleryImage";

interface IGalleryID {
  id: number;
}
 
const GalleryView = () => {
  const location = useLocation();
  const { setLoading } = useLoader();
  const { galleryBannerData, setGalleryBannerData } = useGalleryBannerContext();
  const { galleryImageData, setGalleryImageData } = useGalleryImageContext();
  const [galleryId, setGalleryId] = useState<IGalleryID>({
    id: 0,
  });

  useEffect(() => {
    if (location.state) {
      setGalleryId(location.state);
    }
    window.scrollTo(0, 0);
  }, [location.state]);

  useEffect(() => {
    if (galleryBannerData.length === 0 || galleryImageData.length === 0) {
      Promise.all([fetchGalleryBanner(), fetchGalleryData()])
        .then(([GalleryBannerData, GalleryImageData]) => {
          setGalleryBannerData(GalleryBannerData);
          setGalleryImageData(GalleryImageData);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
          dynamicFailed("Server Error");
        });
    }
  }, [
    galleryBannerData.length,
    galleryImageData.length,
    setGalleryBannerData,
    setGalleryImageData,
    setLoading,
  ]);
  return (
    <>
      <GalleryBanner galleryBannerData={galleryBannerData} />
      <GalleryImage id={galleryId.id} />
    </>
  );
};

export default GalleryView;
